import { createContext, useContext, useState, useEffect } from "react";

const SchoolContext = createContext();

export function SchoolProvider({ children }) {
  const [currentSchoolId, setCurrentSchoolId] = useState(null);

  // Load saved selection from localStorage
  useEffect(() => {
    const saved = localStorage.getItem("currentSchoolId");
    if (saved) setCurrentSchoolId(Number(saved));
  }, []);

  // Persist selection
  useEffect(() => {
    if (currentSchoolId) {
      localStorage.setItem("currentSchoolId", currentSchoolId);
    }
  }, [currentSchoolId]);

  return (
    <SchoolContext.Provider value={{ currentSchoolId, setCurrentSchoolId }}>
      {children}
    </SchoolContext.Provider>
  );
}

export function useSchool() {
  return useContext(SchoolContext);
}